module.exports = __webpack_public_path__ + "img/516af87.png";